import { render, staticRenderFns } from "./Tip4.vue?vue&type=template&id=0a5072ed&scoped=true&lang=pug"
import script from "./Tip4.vue?vue&type=script&lang=ts"
export * from "./Tip4.vue?vue&type=script&lang=ts"
import style0 from "./Tip4.vue?vue&type=style&index=0&id=0a5072ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5072ed",
  null
  
)

export default component.exports